<script setup>
import { useI18n } from "vue-i18n";
import SignUp from "@/Components/SignUp/SignUp.vue";
const { t } = useI18n();
</script>
<template>
  <div class="section-container">
    <div class="relative z-10 flex flex-col justify-center items-start w-full text-left h-full">
      <!-- Title -->
      <h2 class="text-4xl md:text-5xl mb-16 text-center">{{ t("Hoe werkt het?") }}</h2>
      <SignUp />

      <!-- 4:8 Grid Layout -->
      <!-- <div class="grid grid-cols-1 md:grid-cols-12 gap-8 items-start px-6 md:px-0">
       
        <div class="md:col-span-4 flex justify-center min-h-[450px]">
          <img
            src="@/../img/home/register-page.avif"
            alt="Hoe werkt het?"
            class="w-full max-w-sm rounded-lg shadow-md object-contain"
          />
        </div>
       
        <div class="md:col-span-8 min-h-[450px] bg-transparent">
         
        </div>
      </div>-->
    </div>
  </div>
</template>